import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=2242976a&scoped=true"
import script from "./ResponsiveImage.vue?vue&type=script&lang=js"
export * from "./ResponsiveImage.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveImage.vue?vue&type=style&index=0&id=2242976a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242976a",
  null
  
)

export default component.exports